import { render, staticRenderFns } from "./wxjsapi.vue?vue&type=template&id=24fa474d&scoped=true"
import script from "./wxjsapi.vue?vue&type=script&lang=js"
export * from "./wxjsapi.vue?vue&type=script&lang=js"
import style0 from "./wxjsapi.vue?vue&type=style&index=0&id=24fa474d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fa474d",
  null
  
)

export default component.exports